<template>
  <div class="mytieZi" >

    <mt-navbar :fixed="true" v-model="selected" style="border-bottom:1px solid lightgray;">
      <mt-tab-item  id="1" style="border-right:1px solid lightgray;">我的帖子</mt-tab-item>
 <!--     <mt-tab-item  id="2" >我要发帖</mt-tab-item>-->
    <!--  <el-button  @click="logout()">退出</el-button>-->
    </mt-navbar>

    <!-- tab-container -->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="1">
        <contentText/>
      </mt-tab-container-item>
    <!--  <mt-tab-container-item id="2">
        <div style="margin-top:-20px;">
        <tieZi/>
        </div>
      </mt-tab-container-item>-->
    </mt-tab-container>
    <wv-tabbar :fixed="true">
      <wv-tabbar-item to="/" is-on>
        <span slot="icon" style="display: inline-block; position: relative;">
          <img class="weui-tabbar__icon" src="../assets/eye.png" slot="icon">
        </span>
        发现
      </wv-tabbar-item>
      <div v-if="roleType==='2'">
        <wv-tabbar-item to="/tieZi" >
          <img class="weui-tabbar__icon" src="../assets/edit.png" slot="icon"> 发帖
        </wv-tabbar-item>
      </div>
      <wv-tabbar-item >
        <img class="weui-tabbar__icon" src="../assets/logout.png" slot="icon" @click="logout()"> 退出
      </wv-tabbar-item>
    </wv-tabbar>

  </div>
</template>

<script>
  import contentText from './contentText'
  import tieZi from './tieZi'
  export default {
    data() {
      return {
        selected:"1",
        roleType:this.$store.state.roleType,
      }
    },
    mounted(){
      //console.log("mytie-----------");
    },

    methods: {
      //点击退出清除用户的cookie数据以及跳转到首页
      logout(){
        //退出清除用户的cookie数据
        //清除cookie

        var that = this
        that.$Cookies.remove('userName');
        that.$Cookies.remove('password');
        //删除所有
        window.localStorage.clear();
        /*window.localStorage.removeItem('Flag');  //清除文件
        window.localStorage.removeItem('userId');  //清除文件
        window.localStorage.removeItem('username');  //清除文件
        window.localStorage.removeItem('usertype');  //清除文件
        window.localStorage.removeItem('telePhone');  //清除文件
        window.localStorage.removeItem('identity');  //清除文件
*/
       /*   this.$router.push({
          path: '/'
        })*/
        window.location.href = "/";
      },

    },


    components:{
      tieZi,contentText
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/baseScss.scss";
  .mytieZi {
    margin-top:30px;
    .mint-navbar{
      a{
        .mint-tab-item-label{
        }
      }

      .mint-tab-item{
        padding:10px 0;
      }
      .mint-tab-item-label{
        font-size: 14px;
        border-right: solid 1px #999;
      }
    }
    .mint-tab-item.is-selected{
      border:none;
    }
    .is-selected{
      margin-bottom: 0px !important;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/myTZ.vue